module.exports = __webpack_public_path__ + "media/toolkits/HVAC-desktop-ecosystem-9b34d17d.jpg";